/* access-required.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./access-required.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useEffect } from 'react';
import { useIntl } from 'react-intl-next';
import EmptyState from '@atlaskit/empty-state';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import { N400 } from '@atlaskit/theme/colors';
import { fontFallback } from '@atlaskit/theme/typography';
import { useDatasourceAnalyticsEvents } from '../../../analytics';
import { SpotPadlockKey } from '../../../common/ui/spot/basics/padlock-key';
import { AccessRequiredSVGOld } from './access-required-svg';
import { loadingErrorMessages } from './messages';
var styles = {
  iconContainerStyles: "_otyrpxbi",
  descriptionMessageStyles: "_zulppxbi _1e0c1txw _2lx21bp4",
  urlStyles: "_11c82smr _syaznoz8"
};
var Description = function Description(_ref) {
  var message = _ref.message,
    url = _ref.url;
  return /*#__PURE__*/React.createElement("div", {
    className: ax([styles.descriptionMessageStyles])
  }, /*#__PURE__*/React.createElement("span", {
    className: ax([styles.urlStyles])
  }, url), /*#__PURE__*/React.createElement("span", null, message));
};
var noop = function noop() {
  return '';
};
var IconContainer = function IconContainer() {
  var _ref2 = fg('bandicoots-update-sllv-icons') ?
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useIntl() : {
      formatMessage: noop
    },
    formatMessage = _ref2.formatMessage;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.iconContainerStyles
  }, fg('bandicoots-update-sllv-icons') ? /*#__PURE__*/React.createElement(SpotPadlockKey, {
    size: 'xlarge',
    alt: formatMessage(loadingErrorMessages.accessRequired)
  }) : /*#__PURE__*/React.createElement(AccessRequiredSVGOld, null));
};
export var AccessRequired = function AccessRequired(_ref3) {
  var url = _ref3.url;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  var _useDatasourceAnalyti = useDatasourceAnalyticsEvents(),
    fireEvent = _useDatasourceAnalyti.fireEvent;
  useEffect(function () {
    fireEvent('ui.error.shown', {
      reason: 'access'
    });
  }, [fireEvent]);
  if (url) {
    return /*#__PURE__*/React.createElement(EmptyState, {
      testId: "datasource--access-required-with-url",
      header: formatMessage(loadingErrorMessages.accessRequiredWithSite),
      description: /*#__PURE__*/React.createElement(Description, {
        message: formatMessage(loadingErrorMessages.accessInstructions),
        url: url
      }),
      renderImage: IconContainer
    });
  }
  return /*#__PURE__*/React.createElement(EmptyState, {
    testId: "datasource--access-required",
    header: formatMessage(loadingErrorMessages.accessRequired),
    description: formatMessage(loadingErrorMessages.accessInstructions),
    renderImage: IconContainer
  });
};